import Joi from "joi";
import { TicketFinancialType } from "../../../enums/ticketFinancialType";

export let ticketSchema = Joi.object({
  title: Joi.string().min(2).required().label("Title"),
  description: Joi.string().required().min(2).label("Description"),
  statusId: Joi.string().min(2).required().label("Status"),
  departmentId: Joi.string().required().min(2).label("Department"),
  categoryId: Joi.string().required().min(2).label("Category"),
  interventionTypeId: Joi.string().min(2).required().label("Intervention type"),
  locationId: Joi.string().required().min(2).label("Location"),
  companyId: Joi.string()
    .required()
    .min(2)
    .invalid("00000000-0000-0000-0000-000000000000")
    .label("Company"),
  priorityId: Joi.string().required().min(2).label("Priority"),
  customerId: Joi.string().required().min(2).label("Customer"),
  contractorId: Joi.string().min(2).required().label("Contractor"),
  dueDate: Joi.string().required().label("Due date"),
  isRecurring: Joi.boolean().required().label("Is recurring"),
  recurringPeriod: Joi.when("isRecurring", {
    is: true,
    then: Joi.number().min(1).max(3).required().label("Recurring period"),
    otherwise: Joi.allow(null, ""),
  }),
  recurringStartTime: Joi.when("isRecurring", {
    is: true,
    then: Joi.number().min(0).max(28).required().label("Recurring Start Time"),
    otherwise: Joi.allow(null, ""),
  }),
  ticketFinancialType: Joi.number()
    .valid(0, 1)
    .required()
    .label("Ticket financial type"),
  financialAssignedToId: Joi.string()
    .min(1)
    .when("ticketFinancialType", {
      is: TicketFinancialType.Billable,
      then: Joi.string().required().label("Financial assigned to id"),
      otherwise: Joi.string().allow(null, "").label("Financial Assigned to id"),
    }),
});
